import styled from '@emotion/styled';
import { Chip } from '@mui/material';
import { useDraggable } from '@dnd-kit/core';

import { Player, Team } from '../types';

type PitchPlayerProps = {
  player: Player;
  team: Team;
  coords?: { x: number | string; y: number | string };
};

const StyledChip = styled(Chip)({
  fontFamily: 'Arial',
  '& .MuiChip-label': {
    overflow: 'visible',
  },
});

const Wrapper = styled('div', {
  shouldForwardProp: (prop) => prop !== 'coords' && prop !== 'player',
})<Partial<PitchPlayerProps>>(({ coords, player }) => {
  return {
    position: player?.position ? 'absolute' : undefined,
    fontWeight: 'bold',
    marginLeft: player?.position ? -80 : undefined,
    marginTop: player?.position ? 50 : undefined,
    width: player?.position ? 160 : undefined,
    left: coords?.x,
    top: coords?.y,
    zIndex: 1000,
    cursor: 'grab',
    '&:active': {
      cursor: 'grabbing',
    },
  };
});

export const PitchPlayer = ({ player, team, coords }: PitchPlayerProps) => {
  const { attributes, isDragging, listeners, setNodeRef, transform } =
    useDraggable({
      id: player.name,
      data: {
        team,
        player,
      },
    });

  const style = transform
    ? {
        transform: `translate3d(${transform.x}px, ${transform.y}px, 0)`,
      }
    : undefined;

  return (
    <Wrapper
      coords={coords}
      player={player}
      ref={setNodeRef}
      style={style}
      {...listeners}
      {...attributes}
    >
      <StyledChip
        label={player.name}
        color={isDragging ? 'secondary' : 'primary'}
      />
    </Wrapper>
  );
};
